export default "__VITE_ASSET__oisn6aLq__"